import { useState } from 'react';
import useCSVNumbersUpdate from 'hooks/useCSVNumbersUpdate';
import CSVTemplateView from 'pages/accounts/users/csv/CSVTemplateView.jsx';
import VerifyCSVView from 'pages/accounts/users/csv/VerifyCSVView';
import VerifyCSVTableView from 'pages/accounts/users/csv/VerifyCSVTableView';
import useCSVNumbersBulkUpdate from 'hooks/useCSVNumbersUpdate/useCSVNumbersBulkUpdate';
import LoadingIndicator from 'components/v4/LoadingIndicator';
import {
    succeedAPIColumns,
    failedAPIColumns,
    succeedAPIColumnsWithPlatform,
    failedAPIColumnsWithPlatform,
    getColumns,
} from 'hooks/useCSVNumbersUpdate/constants';
import APILoadingView from 'pages/accounts/users/csv/APILoadingView';
import APIResultsView from 'pages/accounts/users/csv/APIResultsView';
import Cookies from 'js-cookie';

const useCSVNumbersUpdateUIControl = () => {
    const [viewVerificationResults, setViewVerificationResults] =
        useState(false);
    const [viewAPIResults, setViewAPIResults] = useState(false);
    const [loadingIndicator, setLoadingIndicator] = useState(false);

    const handleViewVerificationResults = () => {
        setViewVerificationResults(true);
        setViewAPIResults(false);
    };

    const handleCancel = () => {
        setLoadingIndicator(true);
        window.location.reload();
    };

    const handleViewAPIResults = () => {
        setViewAPIResults(true);
        setViewVerificationResults(false);
    };

    return {
        viewVerificationResults,
        handleViewVerificationResults,
        handleCancel,
        loadingIndicator,
        handleViewAPIResults,
        viewAPIResults,
    };
};

export default function CSVNumbersUpdate() {
    const {
        handleDownloadCSVTemplate,
        handleUploadData,
        templateLoading,
        verificationChecks,
        uploadData,
        handleExportInvalidData,
        handleExportModifiedData,
        handleExportUnchangedData,
        verificationResult,
        payloads,
        error: verificationError,
        csvLimit,
    } = useCSVNumbersUpdate();

    const {
        viewVerificationResults,
        handleViewVerificationResults,
        handleCancel,
        handleViewAPIResults,
        loadingIndicator,
        viewAPIResults,
    } = useCSVNumbersUpdateUIControl();

    const {
        handlePayloadChange,
        loading: apiLoading,
        counter,
        errorCounter,
        error,
        succeed,
        handleExportFailedData,
        handleExportSucceedData,
        total,
    } = useCSVNumbersBulkUpdate();

    const platformName = Cookies.get('selectedPlatformName');
    const { passedColumns, failedColumns } = getColumns(platformName);
    console.log(passedColumns, failedColumns, 'passedColumns, failedColumns');
    if (loadingIndicator) {
        return (
            <>
                <LoadingIndicator />
            </>
        );
    }

    if (verificationError) {
        return (
            <>
                <VerifyCSVView
                    handleStartOver={handleCancel}
                    errors={verificationError}
                />
            </>
        );
    }

    if (viewAPIResults) {
        return (
            <>
                <APIResultsView
                    error={error}
                    succeed={succeed}
                    handleExportFailedData={handleExportFailedData}
                    handleExportSucceedData={handleExportSucceedData}
                    handleDone={handleCancel}
                    succeedAPIColumns={
                        platformName === 'Priority'
                            ? succeedAPIColumnsWithPlatform
                            : succeedAPIColumns
                    }
                    failedAPIColumns={
                        platformName === 'Priority'
                            ? failedAPIColumnsWithPlatform
                            : failedAPIColumns
                    }
                />
            </>
        );
    }

    if (apiLoading) {
        return (
            <>
                <APILoadingView
                    completionCounter={counter}
                    payloads={payloads}
                    verificationResult={verificationResult}
                    errorCounter={errorCounter}
                    handleViewAPIResults={handleViewAPIResults}
                    total={total}
                />
            </>
        );
    }

    if (viewVerificationResults) {
        return (
            <>
                <VerifyCSVTableView
                    verificationResult={verificationResult}
                    handleCancel={handleCancel}
                    handleImport={() => {
                        handlePayloadChange(payloads);
                    }}
                    passedColumns={passedColumns}
                    failedColumns={failedColumns}
                    handleExportInvalidData={handleExportInvalidData}
                    handleExportModifiedData={handleExportModifiedData}
                    handleExportUnchangedData={handleExportUnchangedData}
                    handleStartOver={handleCancel}
                />
            </>
        );
    }

    if (uploadData) {
        return (
            <>
                <VerifyCSVView
                    handleViewVerificationResults={
                        handleViewVerificationResults
                    }
                    verificationChecks={verificationChecks}
                />
            </>
        );
    }

    return (
        <>
            <CSVTemplateView
                handleUploadUsersData={handleUploadData}
                enablePlatformSelection
                isUserPage={false}
                downloadCSVText="Download"
                header="CSV Upload"
                step1Text="Step 1 - Download the CSV template"
                step2Text="Step 3 - Upload CSV to be imported"
                instructionsHeader="Instructions"
                handleDownloadTemplate={handleDownloadCSVTemplate}
                loading={templateLoading}
                bgColor="white"
                csvLimit={csvLimit}
            />
        </>
    );
}
